import React from "react";
//#region types
import { DimensionSelectorProps, DimensionTypeItemMultiple } from "models/propTypes/dimensionPropTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import DimensionsAutoCompleteInput from "./autoCompleteInput";
import DimensionSelectionGroup from "./selectionGroup";
//#endregion

const DimensionSelector: React.FC<DimensionSelectorProps> = (props) => {
  const {
    dimensionType,
    onSelectionChange,
    onViewAllClick,
    viewAllButtonText,
    enableSingleSelectionMode,
    hideSelectionDialogFooter,
    dimensionPresetType,
    amount,
    currency,
    readonly,
    disabled,
    hideViewAll,
    fileViewer,
  } = props;

  return (
    <Grid container rowSpacing={1}>
      {!disabled && !readonly && (
        <Grid item container>
          <DimensionsAutoCompleteInput
            dimensionType={dimensionType}
            onItemsSelect={onSelectionChange.bind(null, dimensionType.id, true, false)}
            disabled={props.disabled}
            enableSingleSelectionMode={enableSingleSelectionMode}
            onSelectionDelete={onSelectionChange.bind(null, dimensionType.id, false, false)}
            error={props.error}
            optional={props.optional}
          />
        </Grid>
      )}
      <Grid item container>
        <DimensionSelectionGroup
          dimensionType={dimensionType as DimensionTypeItemMultiple<SelectionItem>}
          onSelectionChange={onSelectionChange}
          onViewAllClick={onViewAllClick}
          viewAllButtonText={viewAllButtonText}
          enableSingleSelectionMode={enableSingleSelectionMode}
          hideSelectionDialogFooter={hideSelectionDialogFooter}
          dimensionPresetType={dimensionPresetType}
          amount={amount}
          currency={currency}
          disabled={disabled}
          readonly={readonly}
          hideViewAll={hideViewAll}
          fileViewer={fileViewer}
        />
      </Grid>
    </Grid>
  );
};

export default DimensionSelector;
